import { Table, Grid, Flex, Box, Text, Divider, TextInputField, Button } from '@repay/cactus-web';
import { Shadow } from "../../../../../docs/Design Guides/Shadow";
import * as React from 'react';
export default {
  Table,
  Grid,
  Flex,
  Box,
  Text,
  Divider,
  TextInputField,
  Button,
  Shadow,
  React
};